<template>
    <div class="mc-pager mc-content-pager-bar">
        <div>
            <el-pagination
                :current-page.sync="option.page"
                :page-size.sync="option.per_page"
                :page-sizes="option.per_pages"
                :total="option.total"
                layout="total, sizes, prev, pager, next, jumper"
                @current-change="$_handleCurrentChange"
                @size-change="$_handleSizeChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "mc-pager",
        props: {
            pagerOption: {
                type: Object,
                default: ()=>{
                    return {}
                },
            },
        },
        data(){
            return {
                option: {
                    page: 1,
                    per_page: 5,
                    per_pages: [5,10,15,20,25],
                    total: 0,
                },
            }
        },
        methods: {
            $_handleOption() {
                for(let i in this.pagerOption){
                    if(typeof(this.pagerOption[i]) === "object") {
                        if(this.option[i]) {
                            for(let j in this.pagerOption[i]) {
                                this.option[i][j] = this.pagerOption[i][j];
                            }
                        } else {
                            this.option[i] = this.pagerOption[i];
                        }
                    } else {
                        this.option[i] = this.pagerOption[i]
                    }
                }
            },
            $_handleCurrentChange(val) {
                this.page = val,
                this.$emit('update:pagerOption',this.option);
            },
            $_handleSizeChange(val){
                this.page = 1;
                this.per_page = val;
                this.$emit('update:pagerOption',this.option);
            },
        },
        mounted(){
            this.$_handleOption();
        },
        watch: {
            pagerOption: {
                handler: function(newVal, oldVal) {
                    this.$_handleOption();
                },
                deep: true,
            }
        }
    }
</script>

<style lang="less">
    .mc-pager{
        margin-top:10px;
        display: inline-flex;
        justify-content: center;
        width: 100%;
    }
</style>
